import { getName } from "@rentiohq/shared-frontend/dist/redux/contact/contact.utils";
import { IUser } from "@rentiohq/shared-frontend/dist/types/auth.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { sortBy } from "lodash";
import { IEnabledAccount } from "./EnabledAccountsSelect";

export const getDisplayName = (
  enabledAccount: IEnabledAccount,
  user: IUser,
) => {
  const isPersonal = user.personalAccountId === enabledAccount.id;

  const name = getName(enabledAccount, false);
  if (isPersonal) {
    return `${name} (${getLocalizedText("system.personal")})`;
  }

  return name;
};

export const sortOptionsByInput = (
  options: { label: string; value: number }[],
  input: string,
) => {
  const lowerInput = input.toLowerCase();

  return options.sort((a, b) => {
    const aLabel = a.label.toLowerCase();
    const bLabel = b.label.toLowerCase();

    const aStarts = aLabel.startsWith(lowerInput);
    const bStarts = bLabel.startsWith(lowerInput);

    if (aStarts && !bStarts) return -1;
    if (!aStarts && bStarts) return 1;

    const aIncludes = aLabel.includes(lowerInput);
    const bIncludes = bLabel.includes(lowerInput);

    if (aIncludes && !bIncludes) return -1;
    if (!aIncludes && bIncludes) return 1;

    return aLabel.localeCompare(bLabel);
  });
};

export const getSortedAccounts = (
  options: IEnabledAccount[] = [],
  user: IUser,
) => {
  if (!user) return options;

  return sortBy(options, [
    enabledAccount => (user.personalAccountId === enabledAccount.id ? 0 : 1),
    enabledAccount => getDisplayName(enabledAccount, user),
  ]);
};
